import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './CarouselItemContent.module.scss';
import defaultImg from '../../../../theme/assets/images/pexels-rethaferguson-3059609.jpg';
import { validateCarouselItem } from '../../../../utils/carouselUtils';

function CarouselItemContent({ slide }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // DEBUG MODE - розкоментувати для дебагу розмірів
  // const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      if (newIsMobile !== isMobile) {
        setIsMobile(newIsMobile);
        setImageLoaded(false);
        setImageError(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile]);
  
  const validation = validateCarouselItem(slide);
  
  if (!validation.isActive || !validation.isValid) {
    console.warn('Carousel item validation failed:', validation);
    return null;
  }

  let SLIDE_ROUTE;
  let linkTarget = slide._id;
  
  if (slide.slideType === 'product') {
    SLIDE_ROUTE = 'products/item/';
  } else if (slide.slideType === 'blog') {
    SLIDE_ROUTE = 'blog/';
  } else if (slide.slideType === 'banner') {
    SLIDE_ROUTE = 'products/categories/';
    linkTarget = slide.categoryId?.title;
  }

  const isValidImage = (image) => image && image !== "undefined";

  // Пріоритет: спеціальні картинки каруселі > оригінальні картинки
  const getImageSrc = () => {
    // Спочатку перевіряємо чи є спеціальні картинки каруселі
    if (isMobile && isValidImage(slide.carouselImageMobile)) {
      return slide.carouselImageMobile;
    }
    
    if (!isMobile && isValidImage(slide.carouselImageDesktop)) {
      return slide.carouselImageDesktop;
    }
    
    // Якщо немає спеціальних картинок, використовуємо оригінальні
    return isValidImage(slide.imageFirst) ? slide.imageFirst
      : isValidImage(slide.imageUrl) ? slide.imageUrl
        : defaultImg;
  };

  const imageSrc = getImageSrc();

  const altText = slide.description || slide.title || `Slide related to ${slide.slideType}`;

  return (
    <div className={styles.carouselItemWrapper}>
      {/* DEBUG MODE - розкоментувати для показу інформації про картинки
      <div className={styles.debugInfo}>
        <div>Тип: {slide.slideType || 'unknown'}</div>
        <div>Оригінал: {imageDimensions.width}×{imageDimensions.height}px</div>
        <div>Назва: {slide.title || slide.name || 'без назви'}</div>
      </div>
      */}
      
      <NavLink to={`/${SLIDE_ROUTE}${linkTarget}`} target="_blank">
        {!imageLoaded && !imageError && (
          <div className={styles.imageSkeleton}>
            <div className={styles.skeletonLoader}></div>
          </div>
        )}
        
            <img
              className={styles.carouselImage}
              src={imageSrc}
              alt={altText}
              loading="eager"
              style={{ 
                display: imageLoaded && !imageError ? 'block' : 'none' 
              }}
              onLoad={(e) => {
                setImageLoaded(true);
                /* DEBUG MODE - розкоментувати для збереження розмірів картинки
                setImageDimensions({
                  width: e.target.naturalWidth,
                  height: e.target.naturalHeight
                });
                */
              }}
              onError={() => {
                setImageError(true);
                if (imageSrc !== defaultImg) {
                  setImageError(false);
                }
              }}
            />
        
        {imageError && imageSrc !== defaultImg && (
          <img
            className={styles.carouselImage}
            src={defaultImg}
            alt={altText}
            loading="eager"
            onLoad={() => {
              setImageLoaded(true);
              setImageError(false);
            }}
          />
        )}
      </NavLink>
    </div>
  );
}

export default CarouselItemContent;
